import App from './app';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import { MemoryRouter } from "react-router-dom"; 
import $ from 'jquery';
import initializeTracking from './global';
import * as Sentry from "@sentry/react";

const store = configureStore();

initializeTracking();

var render = () => {
  var app = (
        <>
          <Sentry.ErrorBoundary>
              <Provider store={store}>
                <MemoryRouter>
                  <App isClassic={true} />
                </MemoryRouter>
              </Provider>
          </Sentry.ErrorBoundary>
        </>
      );
  if($('.topic-wp-plugin').length === 0){
    ReactDOM.render(app, $('#usetopicData')[0], () => {
      $('#usetopicData').css('display', 'block');
    });
  }
};

$(document).ready(function(){
  $('#usetopicMain').click(function(){
    $('#usetopicData').css("display","block");
    jQuery('#post-body-content, #normal-sortables, .notice').addClass('usetopic-lesswidth');
    jQuery(window).trigger('resize');
    render();
  });
});

